import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router';
import axios from 'axios';
import ls from 'localstorage-slim';
import { Dropdown } from 'rsuite';
import { useTranslation } from 'react-i18next';

import DataContext from '../context/InvoiceData';

function NewDocument() {
  const { setDocumentType, setDocumentTypeVersion, invoiceSubType, setInvoiceSubType } =
    useContext(DataContext);

  const subDomain = ls.get('subDomain');

  let navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const [typeVersionData, setTypeVersionData] = useState({});
  const [isOpen, setIsOpen] = useState(false);

  let handleChange = event => {
    setTypeVersionData({ ...typeVersionData, [event.target.name]: event.target.value });
  };

  let handleSubTypeChange = eventKey => {
    setInvoiceSubType(eventKey);
    handleIsOpen();
  };

  let handleIsOpen = () => {
    setIsOpen(!isOpen);
  };

  let handleStart = () => {
    axios
      .post(`${subDomain}${process.env.REACT_APP_DJANGO_BASEURL}/invoices/`, typeVersionData)
      .then(response => {
        setDocumentType(
          typeVersionData.document_type === 'i'
            ? 'Invoice'
            : typeVersionData.document_type === 'c'
            ? 'Credit Note'
            : 'Debit Note'
        );
        setDocumentTypeVersion(typeVersionData.document_type_version);
        ls.set('id', response.data.data.id);
        navigate('/submitInvoiceSteps', { state: { showToast: true } });
      })
      .catch(error => {
        console.log(error);
      });
  };

  return (
    <>
      <div className='card-body body m-5'>
        <div
          className={`${
            i18n.language === 'en' ? 'row ms-2' : 'd-flex flex-row-reverse me-2'
          } my-4`}>
          <div className={`${i18n.language === 'en' ? 'me-4' : 'ms-4 text-end'} col-4`}>
            <label htmlFor='type' className='form-label'>
              {t('newDocument.type.title')}
            </label>
            <select
              id='type'
              className='form-select'
              aria-label='Default select example'
              name='document_type'
              onChange={handleChange}>
              <option value=''>{t('newDocument.type.options.plain')}</option>
              <option value='i'>{t('newDocument.type.options.invoice')}</option>
              <option value='c'>{t('newDocument.type.options.credit')}</option>
              <option value='d'>{t('newDocument.type.options.debit')}</option>
            </select>
          </div>
          <div className={`${i18n.language === 'en' ? 'ms-5' : 'me-5 text-end'} col-4`}>
            <label htmlFor='version' className='form-label'>
              {t('newDocument.version.title')}
            </label>
            <select
              id='version'
              className='form-select'
              aria-label='Default select example'
              name='document_type_version'
              onChange={handleChange}>
              <option value=''>{t('newDocument.version.options.plain')}</option>
              <option value='0.9'>{t('newDocument.version.options.noSignature')}</option>
              <option value='1.0'>{t('newDocument.version.options.signature')}</option>
            </select>
          </div>
        </div>

        <div
          className={`${
            i18n.language === 'en' ? 'ms-2 row' : 'd-flex flex-row-reverse text-end me-2'
          } `}>
          <div className='col-9'>
            <label htmlFor='subtype' className='form-label d-block'>
              {t('newDocument.subType.title')}
            </label>
            <Dropdown
              title={
                invoiceSubType
                  ? `${invoiceSubType[0].toUpperCase() + invoiceSubType.slice(1).toLowerCase()}`
                  : t('newDocument.subType.options.plain')
              }
              onSelect={handleSubTypeChange}
              className={`${
                i18n.language === 'en' ? 'text-start' : 'text-end'
              } p-0 bg-white text-dark`}
              open={isOpen}
              placement={`${i18n.language === 'en' ? 'bottomStart' : 'bottomEnd'}`}
              onOpen={handleIsOpen}>
              <Dropdown.Item eventKey={''} style={{ width: '700px' }}>
                <h6>{t('newDocument.subType.options.plain')}</h6>
              </Dropdown.Item>
              <Dropdown.Item eventKey={'default'} style={{ width: '700px' }}>
                <h6>{t('newDocument.subType.options.default.title')}</h6>
                <span className='text-muted'>
                  {t('newDocument.subType.options.default.description')}
                </span>
              </Dropdown.Item>
              <Dropdown.Item eventKey={'simple'} style={{ width: '700px' }}>
                <h6>{t('newDocument.subType.options.simple.title')}</h6>
                <span className='text-wrap text-muted'>
                  {t('newDocument.subType.options.simple.description')}
                </span>
              </Dropdown.Item>
            </Dropdown>
          </div>
        </div>
        <div className='row my-5'>
          <button
            className={`button mx-auto text-center my-auto ${
              Object.values(typeVersionData).filter(value => !!value).length < 2 || !invoiceSubType
                ? 'bg-secondary bg-gradient'
                : ''
            }`}
            onClick={handleStart}
            disabled={
              Object.values(typeVersionData).filter(value => !!value).length < 2 || !invoiceSubType
            }>
            {t('newDocument.button')}
          </button>
        </div>
      </div>
    </>
  );
}

export default NewDocument;
